<template>
  <PopUp
    :pop-up-active="popupActive"
    :title="title"
    @click="$_popUpClose()"
  >
    <div class="popup-content">
      <div class="dropdown-wrap">
        <p class="dropdown-title">
          {{ $t('選擇版本') }}
        </p>
        <DropdownMenuButton
          v-model="popupContentTabs.selectedMenuItem"
          :dropdown-menu-item="popupContentTabs.menuItems"
          outline
          @click="$_contentTabOnclick(popupContentTabs.selectedMenuItem)"
        />
      </div>
      <slot />
    </div>
  </PopUp>
</template>
<script>
export default {
  name: "AppVersionPopup",
  props: {
    popupActive: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    popupContentTabs: {
      type: Object,
      default() {
        return {
          selectedMenuItem: "0",
          menuItems: [
            {
              id: "0",
              textLabel: "2020.04.04",
            },
            {
              id: "1",
              textLabel: "2020.04.05",
            },
          ],
        };
      },
    },
  },
  methods: {
    $_popUpClose() {
      this.$emit("click");
    },
    $_contentTabOnclick($event) {
      this.$emit("version-tab-click", $event);
    },
  },
};
</script>